/**
 * Messages UX après envoi cuisine — fondés sur la réponse serveur.
 */

export function formatPrepSendSuccessToast(outcome) {
  if (outcome?.replay) {
    return 'Déjà envoyé en préparation (idempotent)';
  }
  const sent = outcome?.report?.sentCount ?? outcome?.lines?.length ?? 0;
  if (sent <= 0) {
    return null;
  }
  const stations = outcome?.report?.stationLabels || [];
  const stationPart =
    stations.length > 0 ? ` → ${stations.join(', ')}` : '';
  const skipped = outcome?.report?.skipped;
  const already = skipped?.alreadySent?.length || 0;
  if (already > 0) {
    return `${sent} ligne(s) envoyée(s)${stationPart} · ${already} déjà en cuisine`;
  }
  return `${sent} ligne(s) envoyée(s) en préparation${stationPart}`;
}

export function formatPrepNothingToSendToast(err) {
  if (err?.code === 'PREP_COMMANDE_CANCELLED') {
    return err?.message || 'Addition annulée — envoi cuisine impossible';
  }
  const details = err?.details || err?.data?.details;
  const already = details?.alreadySentCount ?? details?.skipped?.alreadySent?.length ?? 0;
  const noPrep = details?.skippedNoPrepCount ?? details?.skipped?.noPrep?.length ?? 0;
  if (already > 0 && noPrep === 0) {
    return 'Rien de nouveau à envoyer — toutes les lignes éligibles sont déjà en cuisine';
  }
  if (noPrep > 0 && already === 0) {
    return 'Aucune ligne à envoyer — aucun article ne nécessite de préparation';
  }
  if (already > 0 && noPrep > 0) {
    return `Aucun envoi — ${already} déjà en cuisine, ${noPrep} sans préparation`;
  }
  return err?.message || 'Aucune ligne à envoyer en préparation';
}
